<script setup>
import ContactReasonTreeItem from './ContactReasonTreeItem.vue';

defineProps({
  contactReasons: {
    type: Array,
    required: true,
  },
  rootNode: {
    type: Boolean,
    default: false,
  },
  level: {
    type: Number,
    default: 1,
  },
  contactReasonPath: {
    type: Array,
    default: () => [],
  },
  selectedId: {
    type: Number,
    default: null,
  },
});

const emit = defineEmits(['selectContactReason', 'created']);
</script>

<template>
  <ul class="tree" :class="{ 'tree-root': rootNode }">
    <ContactReasonTreeItem
      v-for="reason in contactReasons"
      :key="reason.id"
      :level="level"
      :contact-reason-path="[...contactReasonPath, reason.id]"
      :reason="reason"
      :selected-id="selectedId"
      @select-contact-reason="emit('selectContactReason', $event)"
      @created="emit('created', $event)"
    />
  </ul>
</template>

<style scoped>
.tree {
  list-style: none;
  line-height: 2em;
  padding-left: 1.5em !important;
}

.tree li {
  position: relative;
}

.tree li::before {
  @apply absolute border-l-2 border-b-2 border-l-n-slate-4 border-b-n-slate-4;
  left: -10px;
  top: 0px;
  content: '';
  width: 1.1em;
  height: 1.4em;
}

.tree li::after {
  @apply h-full absolute border-l-2 border-l-n-slate-4;
  left: -10px;
  bottom: 0px;
  content: '';
}

.tree li:last-child::after {
  display: none;
}

.tree-root > li:after,
.tree-root > li:before {
  display: none;
}

.tree-root {
  padding-left: 0px !important;
}
</style>
